export default "__VITE_ASSET__C7dfc94U__"